const ENV = process.env.NODE_ENV || 'development';
let conf2merge = {};

let defaultConf = {
    apiUrl: process.config.API_ENDPOINT,
    socketEndpoint: process.config.SOCKET_ENDPOINT,
    socket: {
        events: {
            QUEUES_UPDATE: 'queues_update',
            QUEUE_DETAILS: 'queue_details',
            SUBSCRIBE_TO_QUEUE: 'subscribe_to_queue',
            UNSUBSCRIBE_FROM_QUEUE: 'unsubscribe_from_queue',
        }
    }
};

export default Object.assign({}, defaultConf, conf2merge);


// WEBPACK FOOTER //
// ./src/config/index.js